import type React from "react";
import { ReactComponent as Svg } from "./assets/pencil-1.svg";
import * as styles from "./Icon.module.scss";

type PencilProps = React.SVGProps<SVGSVGElement>;

export const Pencil = ({ className, ...props }: PencilProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
